<template>
  <rect width="16" height="16" fill="black" fill-opacity="0.01" />
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M5.57574 3.07574C5.81005 2.84142 6.18995 2.84142 6.42426 3.07574L10.9243 7.57574C11.1586 7.81005 11.1586 8.18995 10.9243 8.42426L6.42426 12.9243C6.18995 13.1586 5.81005 13.1586 5.57574 12.9243C5.34142 12.6899 5.34142 12.3101 5.57574 12.0757L9.65147 8L5.57574 3.92426C5.34142 3.68995 5.34142 3.31005 5.57574 3.07574Z"
    fill="currentColor" />
</template>
